import { Pipe, PipeTransform } from '@angular/core';
import convert from 'convert';

@Pipe({
    name: 'convertUom',
    standalone: false
})
export class ConvertUomPipe implements PipeTransform {
  preferredUOM;
  newval;
  transform(text: any, arg1: any): unknown {
    this.preferredUOM = localStorage.getItem('preferredUOM');
    if(text){
    if (this.preferredUOM !== null && text !== " ") {
      let updatedText = text.split(" ");
      let data = JSON.parse(updatedText[0]);
      let suffix = updatedText[1];
      switch (this.preferredUOM) {
        case 'imperial':
          if (suffix == 'CUIN') {
            this.newval = convert(data, 'cubic inch').to('cubic feet');
            return this.newval.toFixed(2) + " CUFT";
          }
          if (suffix == 'CUYD') {
            return (data * 27).toFixed(2) + " CUFT";
          }
          if (suffix == 'CUFT' || suffix == "LB") {
            return text;
          }
          if (suffix == "KG") {
            this.newval = convert(data, 'kg').to('lb');
            return this.newval.toFixed(2) + " LB";
          }
          if (suffix == "CUMTR") {
            this.newval = convert(data, 'cubic meter').to('cubic feet');
            return this.newval.toFixed(2) + " CUFT";
          }
          if (suffix == "TON") {
            return (data * 2204.6226218).toFixed(2) + " LB";
          }
          if (suffix == "MTON") {
            return (data * 2204.6226218).toFixed(2) + " LB";
          }
          if (suffix === "L") {
            return `${(convert(Number(data), 'liters').to('gallons')).toFixed(2)} GAL`;
          }
        case 'metric':
          if (suffix == "LB") {
            this.newval = convert(data, 'lb').to('kg');
            return this.newval.toFixed(2) + " KG";
          }
          if (suffix == "KG" || suffix == "CUMTR" ) {
            return text;
          }
          if (suffix == "CUIN") {
            this.newval = convert(data, 'cubic inch').to('cubic meter');
            return this.newval.toFixed(2) + " CUMTR";
          }
          if (suffix == "CUFT") {
            this.newval = convert(data, 'cubic feet').to('cubic meter');
            return this.newval.toFixed(2) + " CUMTR"
          }
          if (suffix == 'CUYD') {
            this.newval = convert(data, 'cubic yard').to('cubic meter');
            return this.newval.toFixed(2) + " CUMTR";
          }
          if (suffix == "TON") {
            return (data * 1000).toFixed(2) + " KG";
          }
          if (suffix == "MTON") {
            return (data * 1000).toFixed(2) + " KG";
          }
          if (suffix == "L") {     
            this.newval = convert(data, 'liters').to('cubic meter');
            return  this.newval.toFixed(2) + " CUMTR"       
          }
          if (suffix === "GAL") {
            return `${(convert(Number(data), 'gallons').to('liters')).toFixed(2)} L`;
          }
      }
    }
    else {
      return text
    }
    }
  }
}
